import React from 'react';
import {
  CalendarYearYearlyTimeSelectionInput,
  CohortMetricId,
} from '../../../../api/types-graphql';
import { DashboardConfig } from '../../../../common/components/dashboards/types';
import { Languages } from '../../../../constants';
import { HcSimulationPage } from '../../../../pages/dashboards/HCSimulationDashboard/HcSimulationPage';
import {
  DataFieldWithDataType,
  DataTypes,
  EmployeeDataFields,
} from '../../../../types';

const dashboardId = 'hc-simulation';

const iPexSegmentFields: DataFieldWithDataType[] = [
  {
    dataType: DataTypes.EMPLOYEE,
    dataField: EmployeeDataFields.AGE_GROUP,
  },
  {
    dataType: DataTypes.EMPLOYEE,
    dataField: EmployeeDataFields.ORGANIZATION,
  },
  {
    dataType: DataTypes.EMPLOYEE,
    dataField: EmployeeDataFields.GENDER,
  },
];

const iPexSimulationYearRange: CalendarYearYearlyTimeSelectionInput = {
  start: 2026,
  end: 2035,
};

const IPexHcSimulationPage = () => (
  <HcSimulationPage
    segmentFields={iPexSegmentFields}
    simulationMetrics={[CohortMetricId.Pm0417_2SimulatedHeadcountCount]}
    simulationYearRange={iPexSimulationYearRange}
  />
);

export const IPexHcSimulationDashboardConfig: DashboardConfig = {
  id: dashboardId,
  title: {
    [Languages.EN]: 'HC Simulation Dashboard',
    [Languages.JA]: '要員計画シミュレーション結果',
  },
  enabled: true,
  pages: [
    {
      pageId: '1',
      dashboardId,
      pageNumber: 1,
      enabled: true,
      title: {
        [Languages.EN]: 'HC Simulation Page 1',
        [Languages.JA]: '要員計画シミュレーション結果',
      },
      pageOptions: {
        dataView: {
          enabled: false,
        },
        filterTray: {
          enabled: false,
        },
        segmentationLevel1: {
          enabled: false,
        },
        segmentationLevel2: {
          enabled: false,
        },
        benchmark: {
          enabled: false,
        },
        forecast: {
          enabled: false,
        },
        timeOptions: {
          timeSliderEnabled: false,
        },
      },
      gridRows: 1,
      gridCols: 1,
      configType: 'pageComponent',
      pageComponent: IPexHcSimulationPage,
      link: '/dashboard/headcount-simulation/2',
    },
  ],
};
